import React from 'react';

import isNil from 'lodash/isNil';

import { TestTypeMultiSelect } from '@qality/common-components/src/picker/TestTypeMultiSelect';
import { TestType } from '@qality/common-model';
import { useTestTypesContext } from '@qality/common-pages';

type Props = {
  testTypesIds: string;
  setTestTypesids: (testTypesIds: string) => void;
  onChange: (value: Array<{ name: string; value: Array<any> }>) => void;
};

export default function TestTypeReportFilter({
  testTypesIds,
  setTestTypesids,
  onChange,
}: Props) {
  const { testTypes, isLoading, getTestType } = useTestTypesContext();

  const selectedTestTypes = testTypesIds
    .split(',')
    .map((id) => getTestType(parseInt(id, 10)))
    .filter((id) => !isNil(id));

  const handleOnChange = (newSelectedTestTypes: TestType[]) => {
    const testTypesIdsString =
      newSelectedTestTypes.map(({ id }) => id).join(',') || '';

    const testTypesIdsArray = newSelectedTestTypes.map(({ id }) => id);

    //report filters contain test type ids in form of an array
    onChange([{ name: 'testTypesIds', value: testTypesIdsArray }]);

    //report testTypesIds state contains test types ids in form of an url param string
    setTestTypesids(testTypesIdsString);
  };

  return (
    <TestTypeMultiSelect
      testTypes={testTypes}
      isTestTypesLoaded={!isLoading}
      selectedTestTypes={selectedTestTypes}
      onChange={handleOnChange}
      minWidth={300}
    />
  );
}
